export const DELETE_PARTNER_RESOURCES = gql`
    mutation deletePartnerResource($input: DeleteResourceInput!) {
        deletePartnerResource(input: $input) {
            status
        }
    }
`;
